import { Button, IconButton } from '@mui/material';
import { useTheme } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';
import * as React from 'react';

import muiStyles from './styles';
import { StateButtonProps } from './types';

export default function StateButton(props: StateButtonProps) {
    const {
        className,
        id,
        Icon,
        text,
        state,
        handleClick,
        disabled
    } = props;

    const classes = muiStyles(props);
    const theme = useTheme<typeof muiTheme>();

    if (Icon && !text) {
        return (
            <IconButton
                className={`${classes.root} ${className} ${classes.iconContainer}
                    ${state === 'active' ? classes.active : classes.inactive}`}
                disabled={disabled}
                id={id}
                onClick={handleClick}
            >
                <Icon
                    className={classes.icon}
                    iconColor={state === 'active' ?
                        theme?.app?.applicationColors.enumColors.white || '#fff'
                        : theme?.app?.applicationColors.enumColors.greyLighter || '#cfcfcf'}
                />
            </IconButton>
        );
    }

    return (
        <Button
            className={`${classes.root} ${className} ${classes.textContainer}
                ${state === 'active' ? classes.active : classes.inactive}`}
            disabled={disabled}
            id={id}
            onClick={handleClick}
        >
            {text}
        </Button>
    );
}